import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useStore, useSelector, useDispatch } from 'react-redux'
import { Card, Box, Button, IconButton, Stack, Tooltip, Chip } from '@mui/material'
import { newPost } from '../../helper/baseFetch'
import { newGetList } from '../../helper/baseFetch_v2'
import MultiLangLabel from '../../Component/common/label/MultiLangLabel'
import MUITable from '../../Component/common/table/MUITable'
import { ListFilter } from '../../Component/ListDisplay/ListFilter'
import Iconify from '../../Component/common/iconify/Iconify'
import { ICONIFY } from '../../Constants/iconify'
import { API_PATH } from '../../Constants/path'
import { Add } from '@mui/icons-material'
import SharedDialog from '../../Component/common/dialog/SharedDialog'
import SurveyPanel from '../../Component/Flow/survey/SurveyPanel'
import SurveyDialog from '../../Component/Flow/survey/SurveyDialog'
import { setSurveyFlow } from '../../actions/surveyFlowAction'
import { constants } from '../../Constants/constants'
import { KEYS_OF_DRAFT_DATA, KEYS_OF_IS_CREATE, KEYS_OF_TEMP_DRAFT_DATA, PREFIX_OF_TEMP_NODE } from '../../Component/Flow/constant'
import StatusLabel from '../../Component/_v2/label/StatusChip'
import { getString, getQuery, getQueryParamObject, getParamQueryString, standardizeOptions } from '../../helper/util'
// import { convertToQueryString } from '../../helper/urlUtil'
import _ from 'lodash'
import { useListParam } from '../../hooks/useListParam'
import moment from 'moment'

import { chipRender } from './constants'


// survey listing page
export default function AppVersionList({
  newPath,
  editBtn = true,
  createBtn = true,
  cloneBtn = true,
  onClickListRow,
  readOnly = false,
  dialogFooterBtn,
  newListFilters
}) {
  const changeUrlQueryString = newListFilters ? false : true
  const resource = 'appVersionPage'
  const filterParams = getQuery()
  const currentRole = localStorage.getItem(constants.LOCAL_STORAGE_KEY.ROLE)
  const isDeveloper = currentRole === constants.ROLE.DEVELOPER || currentRole === constants.ROLE.ROLE_SUPER_ADMIN

  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)


  const AppVersionListTitleList = [
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'title',
          sort: true,
        },
        {
          key: constants.LIST_DISPLAY_TYPE.STRING,
          value: 'status',
          sort: true,
        },
      ]

  const listFilters = newListFilters ? 
    newListFilters : [
    {
      className: 'filter-input',
      label: { resource: resource, key: 'appVersion' },
      clear: true,
      value: '',
      name: 'appVersion',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'buildNumber' },
      clear: true,
      value: '',
      name: 'buildNumber',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'customCode' },
      clear: true,
      value: '',
      name: 'customCode',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'buildTarget' },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: standardizeOptions(constants.CHOICES.APP_VERSION.BUILD_TARGET, 'value', 'name'),
      name: 'buildTarget',
      size: constants.SIZE.SMALL,
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'status' },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.APP_VERSION.STATUS,
      name: 'statusList',
      size: constants.SIZE.SMALL,
    },
  ]

  const {
    param,
    setParam,
    onChangeParam,
    onChangeListFilters,
    onChangeListSort,
    onChangeListPage: onChangeListPageParam,
    onChangeListRowsPerPage: onChangeListRowsPerPageParam,
  } = useListParam({
    initialPath: newPath ? newPath : '',
    initialListFilters: _.cloneDeep(listFilters),
    listTitles: AppVersionListTitleList,
    initialSort: 'updateTimestamp',
    initialDirection: 'DESC',
    initialPage: 0,
    initialRowsPerPage: 10,
    changeUrlQueryString,
  })

  const formatDate = (timestamp) => {
    if (!timestamp) return ''
    return moment(timestamp).locale('en').format('D MMM YYYY, h:mm A')
  }

  const columns = [
    {
      field: 'appVersion',
      headerName: 'App Version',
      width: 150,
      flex: 1,
      renderCell: (params) => {
        const releaseList = params.row.releaseList ?? []
        // Collect all unique tags across all releases
        const allTags = [...new Set(releaseList.flatMap((r) => r.tagList ?? []))]
        return (
          <>
            <div>{params.row.appVersion}</div>
            <div style={{ marginTop: 4 }}>
              {allTags.map((tag) => (
                <Chip key={tag} label={tag} size="small" sx={{ m: 0.5 }} />
              ))}
            </div>
          </>
        )
      },
    },
    // {
    //   field: 'buildNumber',
    //   headerName: 'Build Number',
    //   width: 100,
    //   flex: 1,
    // },
    // {
    //     field: 'customCode',
    //     headerName: 'Custom Code',
    //     width: 100,
    //     flex: 1,
    // },
    // {
    //   field: 'buildTarget',
    //   headerName: 'Build Target',
    //   width: 150,
    //   renderCell: (params) => {
    //     const targets = params.row.buildTarget
    //     return (
    //       <>
    //         {
    //           targets.androidModern &&  (
    //             <Tooltip title={getString(lang, '', 'ANDROID_MODERN', theme)} placement="left">
    //               <Chip label={'Modern'} icon={<Iconify icon={chipRender('ANDROID_MODERN')?.icon} />} color={chipRender('ANDROID_MODERN')?.color} size="small" sx={{ m: 0.5 }} />
    //             </Tooltip>
    //           )
    //         }
    //         {
    //           targets.androidLegacy &&  (
    //             <Tooltip title={getString(lang, '', 'ANDROID_LEGACY', theme)} placement="left">
    //               <Chip label={'Legacy'} icon={<Iconify icon={chipRender('ANDROID_LEGACY')?.icon} />} color={chipRender('ANDROID_LEGACY')?.color} size="small" sx={{ m: 0.5 }} />
    //             </Tooltip>
    //           )
    //         }
    //         {
    //           targets.androidMpos &&  (
    //             <Tooltip title={getString(lang, '', 'ANDROID_MPOS', theme)} placement="left">
    //               <Chip label={'Mpos'} icon={<Iconify icon={chipRender('ANDROID_MPOS')?.icon} />} color={chipRender('ANDROID_MPOS')?.color} size="small" sx={{ m: 0.5 }} />
    //             </Tooltip>
    //           )
    //         }
    //         {
    //           targets.ios &&  (
    //             <Tooltip title={getString(lang, '', 'IOS', theme)} placement="left">
    //               <Chip label={'IOS'} icon={<Iconify icon={chipRender('IOS')?.icon} />} color={chipRender('IOS')?.color} size="small" sx={{ m: 0.5 }} />
    //             </Tooltip>
    //           )
    //         }
    //       </>
    //     )
    //   }
    // },
    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   width: 50,
    //   renderCell: (params) => <StatusLabel resource={resource} keyName={params.value} />
    // },
    // {
    //   field: 'releaseNote',
    //   headerName: 'Release Note',
    //   width: 250,
    //   renderCell: (params) => {
    //     const releaseNote = params.row.releaseNote
    //     return (
    //       releaseNote && (
    //         <>
    //           <Stack direction="row" alignItems="end" spacing={1} sx={{ maxWidth: 250 }}>
    //             <span style={{display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 250, whiteSpace: 'pre'}}>{releaseNote}</span>
    //             <Tooltip title='view'>
    //               <IconButton component="span" sx={{padding: 0}} onClick={() => setShowDialog({
    //                 title: 'Release Note',
    //                 content: (
    //                   <Box sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
    //                     <div style={{whiteSpace: 'pre'}}>
    //                       {releaseNote}
    //                     </div>
    //                   </Box>
    //                 )
    //               })}>
    //                 <Iconify icon={ICONIFY.eye} />
    //               </IconButton>
    //             </Tooltip>
    //           </Stack>
              
    //         </>
    //       )
    //     )
    //   }
    // },
    // {
    //   field: 'remarks',
    //   headerName: 'Remarks',
    //   width: 180,
    //   flex: 1,
    //   renderCell: (params) => {
    //     const remarks = params.row.remarks
    //     return (
    //       remarks && (
    //         <>
    //           <Stack direction="row" alignItems="end" spacing={1} sx={{ maxWidth: 180 }}>
    //             <span style={{display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 180, whiteSpace: 'pre'}}>{remarks}</span>
    //             <Tooltip title='view'>
    //               <IconButton component="span" sx={{padding: 0}} onClick={() => setShowDialog({
    //                 title: 'Remarks',
    //                 content: (
    //                   <Box sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
    //                     <div style={{whiteSpace: 'pre'}}>
    //                       {remarks}
    //                     </div>
    //                   </Box>
    //                 )
    //               })}>
    //                 <Iconify icon={ICONIFY.eye} />
    //               </IconButton>
    //             </Tooltip>
    //           </Stack>
    //         </>
    //       )
    //     )
    //   }    },
    {
      field: 'customCode',
      headerName: 'Custom Code',
      width: 150,
      renderCell: (params) => {
        const codes = [...new Set((params.row.releaseList ?? []).map((r) => r.customCode).filter(Boolean))]
        return (
          <div>
            {codes.map((code) => (
              <Chip key={code} label={code} size="small" variant="outlined" sx={{ m: 0.25 }} />
            ))}
          </div>
        )
      },
    },
    {
      field: 'createDateTime',
      headerName: 'Create Date',
      width: 170,
      renderCell: (params) => {
        const timestamps = (params.row.releaseList ?? []).map((r) => r.createDateTime).filter(Boolean)
        const earliest = timestamps.length ? Math.min(...timestamps) : null
        return <span>{formatDate(earliest)}</span>
      },
    },
    {
      field: 'updateDateTime',
      headerName: 'Update Date',
      width: 170,
      renderCell: (params) => {
        const timestamps = (params.row.releaseList ?? []).map((r) => r.updateDateTime).filter(Boolean)
        const newest = timestamps.length ? Math.max(...timestamps) : null
        return <span>{formatDate(newest)}</span>
      },
    },
    {
      field: 'modern',
      headerName: 'Modern',
      width: 80,
      renderCell: (params) => {
        const hasStable = (params.row.releaseList ?? []).some(
          (r) => r.status === 'STABLE' && r.buildTarget?.androidModern
        )
        return hasStable ? <Iconify icon="mdi:check-circle" color="success.main" /> : null
      },
    },
    {
      field: 'old',
      headerName: 'Old',
      width: 80,
      renderCell: (params) => {
        const hasStable = (params.row.releaseList ?? []).some(
          (r) => r.status === 'STABLE' && r.buildTarget?.androidLegacy
        )
        return hasStable ? <Iconify icon="mdi:check-circle" color="success.main" /> : null
      },
    },
    {
      field: 'mpos',
      headerName: 'Mpos',
      width: 80,
      renderCell: (params) => {
        const hasStable = (params.row.releaseList ?? []).some(
          (r) => r.status === 'STABLE' && r.buildTarget?.androidMpos
        )
        return hasStable ? <Iconify icon="mdi:check-circle" color="success.main" /> : null
      },
    },
    readOnly ? {} : {
      field: 'actions',
      headerName: 'Actions',
      width: 20,
      renderCell: (params) => {
        const mdUrl = params.row.documentList
        return (
          // <Stack direction="row" spacing={1}>
          <div style={{ display: 'flex', flexWrap: 'nowrap' , gap: 8 }}>
            {
              editBtn && (
                <Tooltip title='edit'>
                  <IconButton onClick={() => onClickEdit(params.row.id)} sx={{ flex: '0 0 auto', p: 0.5 }}>
                    <Iconify icon={ICONIFY.edit} />
                  </IconButton>
                </Tooltip>
              )
            }
            {/* {
              mdUrl && mdUrl.length > 0 && (
                <Tooltip title='documents'>
                  <IconButton onClick={() => setShowDialog({
                    title: 'Document List',
                    content: (
                      <Box sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        {mdUrl.map((md, index) => (
                          <div key={index} style={{ marginBottom: '16px' }}>
                            <a href={md.url} target="_blank" rel="noopener noreferrer">{md.name}</a>
                          </div>
                        ))}
                      </Box>
                    )
                  })} sx={{ flex: '0 0 auto', p: 0.5 }}>
                    <Iconify icon={ICONIFY.document} />
                  </IconButton>
                </Tooltip>
              )
            } */}
          </div>
          // </Stack>
        )
      }
    },
  ]

  const store = useStore()
  const savedAppVersion = useSelector(state => state.appVersion.ui.appVersion)
  const savedAppVersionCommonStatus = useSelector(state => state.appVersion.ui.common)
  const dispatch = useDispatch()

  const history = useHistory()

  const [list, setList] = useState([])
  const [listLength, setListLength] = useState(0)
  const [listPagination, setListPagination] = useState({
    sort: 'updateTimestamp',
    order: 'DESC',
    pageSize: 10,
    page: 0,
    filter: {},
  })
  const [selected, setSelected] = useState([])
  const [showDialog, setShowDialog] = useState({})
  const [isCreateMode, setIsCreateMode] = useState(false)

  const draftId = useRef(null)

  const getList = () => {
    let tempParam = _.cloneDeep(param)
    const filter = {}
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value
      }
    })

    const newListPagination = {
      // ...listPagination,
      ...filter,
      // status: 'STABLE',
      // filter: JSON.stringify(filter),
      androidModern: filter.buildTarget === 'ANDROID_MODERN' ? true : undefined,
      androidLegacy: filter.buildTarget === 'ANDROID_LEGACY' ? true : undefined,
      androidMpos: filter.buildTarget === 'ANDROID_MPOS' ? true : undefined,
      ios: filter.buildTarget === 'IOS' ? true : undefined,
      pageSize: tempParam.rowsPerPage,
      page: tempParam.page,
      sortingList: [
        { sort: 'createDateTime', direction: 'DESC' }
      ]
    }

    // const newListPagination = {
    //   ...listPagination,
    //   // filter: JSON.stringify(listPagination.filter),
    //   filter: JSON.stringify(filter),
    //   // API expects 1-based page index
    //   page: tempParam.page,
    //   perPage: tempParam.rowsPerPage
    // }

    // console.log('getList with pagination', convertToQueryString(newListPagination))

    newGetList({
      // path: API_PATH.survey.base,
      path: 'gulu-console/merchant/shop-app-release',
      queryObj: newListPagination,
      successCallback: (payload) => setList(payload.list),
      store: store,
      getListLength: (listLength) => setListLength(listLength),
    })
  }

  const onClickCreate = () => {
    history.push(`/${constants.PATH.APPVERSION.APPVERSION}/create/0`)
  }

  const onClickEdit = (id) => {
    history.push(`/${constants.PATH.APPVERSION.APPVERSION}/` + id + '/0')
  }

  const handleSubmit = (data) => {
    setIsCreateMode(false)
    dispatch(setSurveyFlow({ ...savedSurveyFlow, ...data }))
    history.push(`/${constants.PATH.APPVERSION.APPVERSION}/` + `${PREFIX_OF_TEMP_NODE}${Date.now()}?${KEYS_OF_IS_CREATE}=true`)
  }

  function onChangeListPage(e, newPage) {
    setListPagination((prev) => ({ ...prev, page: newPage }))
    onChangeListPageParam(newPage)
  }

  function onChangeListRowsPerPage(e) {
    const rowsPerPage = e?.target?.value
    setListPagination((prev) => ({ ...prev, pageSize: rowsPerPage }))
    onChangeListRowsPerPageParam(rowsPerPage)
  }

  // onChangeParam handled by useListParam

  // URL sync and param initialization handled by useListParam

  useEffect(() => {
    getList()
  }, [param.count]) // eslint-disable-line react-hooks/exhaustive-deps

  // keep local pagination state (MUITable) in sync with param (from hook / URL)
  useEffect(() => {
    setListPagination((prev) => ({
      ...prev,
      page: param.page ?? 0,
      pageSize: param.rowsPerPage ?? prev.pageSize,
    }))
  }, [param.page, param.rowsPerPage])

  return (
    <Card>
      {/* <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}> */}
      <Box sx={{ p: 3 }}>
        {/* {!onClickListRow && ( */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="title">
              App Version
            </div>
            {
              isDeveloper && (
                <Button startIcon={<Add />} variant='contained' onClick={onClickCreate}>
                  Create
                </Button>
              )
            }
          </Box>
        {/* )} */}

        <ListFilter onChangeListFilters={onChangeListFilters} listFilters={param.listFilters} />

        <Box sx={{ flex: 1, overflow: 'auto' }}>
          <MUITable
            stickyHeader
            columns={columns}
            rows={list}
            pagination={listPagination}
            setPagination={setListPagination}
            listLength={listLength}
            onClickListRow={onClickListRow}
            handleChangePage={onChangeListPage}
            handleChangeRowsPerPage={onChangeListRowsPerPage}
            stickyEditBtn
            // selected={selected}
            // setSelected={setSelected}
          />
          {dialogFooterBtn}
        </Box>
      </Box>

      <SharedDialog
        maxWidth='md'
        open={Object.keys(showDialog).length > 0}
        title={showDialog?.title || ''}
        onClose={() => setShowDialog({})}
        content={
          <>
            {showDialog?.content ? (
              <Box sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {showDialog.content}
              </Box>
            ) : null}
          </>
        }
        actions={
          <Stack direction={'row'} gap={1}>
            <Button variant='outlined' onClick={() => setShowDialog({})}>Cancel</Button>
            <Button variant='contained' onClick={() => setShowDialog({})}>OK</Button>
          </Stack>
        }
      />

      {/* create dialog */}
      {/* <SurveyDialog
        isEdit={!isCreateMode}
        open={showDialog}
        toggleOpen={setShowDialog}
        handleSubmit={handleSubmit}
      /> */}
    </Card>
  )
}